import { MaterialDeliveredType, mapMaterialDeliveredType } from "./MaterialDeliveredType";
import { MaterialOnsiteType, mapMaterialOnsiteType } from "./MaterialOnsiteType";
import { MaterialOrderType, mapMaterialOrderType } from "./MaterialOrderType";

export interface MaterialStructureType {
    date: string | null;
    order: MaterialOrderType | null;
    delivered: MaterialDeliveredType | null;
    onsite: MaterialOnsiteType | null;
}

// to single object maping
export const mapMaterialStructureType = (data: any): MaterialStructureType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialStructureType: MaterialStructureType = {
        date: data.date || null,
        order: data.order !== null ? mapMaterialOrderType(data.order) : null,
        delivered: data.delivered !== null ? mapMaterialDeliveredType(data.delivered) : null,
        onsite: data.onsite !== null ? mapMaterialOnsiteType(data.onsite) : null,
    }

    return materialStructureType;
}

// maping list objects
export const mapMaterialStructureTypes = (data: any[]): MaterialStructureType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapMaterialStructureType);
}